import React from 'react'
import RequireAuth from '@Components/Utility/RequireAuth'
import SongwriterRegistrationScene from '@Scenes/SongwriterRegistrationScene'
import { REGISTRATION_SONGWRITER_ROUTE } from '@App/navigation/route'

const createRegistrationSongwriterRoutes = () => ({
    path: REGISTRATION_SONGWRITER_ROUTE,
    element: (
        <RequireAuth>
            <SongwriterRegistrationScene />
        </RequireAuth>
    ),
})

export default createRegistrationSongwriterRoutes
